'use client';

import { useRecommendation } from 'hooks/useRecommendation';
import { useAppSelector } from 'lib/hooks';
import { useEffect, useRef } from 'react';
import { selectReadyForRecommendation } from 'slices/selectors';
import { ANALYTICS_EVENTS, capture } from 'lib/analytics';

const RecommendationTrigger = () => {
  const isReady = useAppSelector(selectReadyForRecommendation);
  const triggerRec = useRecommendation({ recordAsShown: true });
  const requestedRef = useRef(false);

  // Auto-trigger if specified in the component data
  useEffect(() => {
    if (isReady) {
      if (!requestedRef.current) {
        requestedRef.current = true;
        capture(ANALYTICS_EVENTS.recommendationRequested);
      }
      triggerRec();
    } else {
      // eslint-disable-next-line no-console
      console.error('Missing required information for recommendations');
    }
  }, [isReady]); // eslint-disable-line react-hooks/exhaustive-deps

  // This component renders nothing - it only handles the API call
  return null;
};

export default RecommendationTrigger;
